import { ActionTypes as DataActionTypes } from '../../actions/data';
export const initialState = {
    status: 'not-fetched',
    timeFetched: null,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case DataActionTypes.CATEGORY_TREE_REQUEST_SUCCESS:
        case DataActionTypes.CATEGORY_TREE_HYDRATE: {
            return {
                status: 'has-fetched',
                timeFetched: action.payload.now,
            };
        }
        case DataActionTypes.CATEGORY_TREE_REQUEST_START: {
            return {
                status: 'is-fetching',
                timeFetched: null,
            };
        }
        case DataActionTypes.CATEGORY_TREE_REQUEST_FAIL:
            return {
                status: 'error',
                timeFetched: null,
            };
    }
    return state;
};
export default reducer;
//# sourceMappingURL=meta.js.map